<template>
  <Navbar2 />
  <HeroArea2 />
  <Feature2 />
  <AboutCompany :className="true" />
  <Service2 :type="true" />
  <Process />
  <FAQ2 />
  <CTA2 />
  <Footer2 />
</template>

<script>
import Navbar2 from "@/components/Navbar2.vue";
import Footer2 from "@/components/Footer2.vue";
import FAQ2 from "@/components/faq/FAQ2.vue";
import HeroArea2 from "@/components/heroArea/HeroArea2.vue";
import Feature2 from "@/components/feature/Feature2.vue";
import AboutCompany from "@/components/about/AboutCompany.vue";
import Service2 from "@/components/service/Service2.vue";
import CTA2 from "@/components/cta/CTA2.vue";
import Process from "@/components/Process.vue";
export default {
  name: "Home2",
  components: {
    Navbar2,
    Footer2,
    FAQ2,
    HeroArea2,
    Feature2,
    AboutCompany,
    Service2,
    CTA2,
    Process,
  },
  mounted() {
    // Add structured data (JSON-LD) for SEO
    this.addStructuredData();
    // data-backround

    $("[data-background]").each(function () {
      $(this).css(
        "background-image",
        "url( " + $(this).attr("data-background") + "  )"
      );
    });

    //jQuery Animation
    new WOW().init();
  },
  methods: {
    addStructuredData() {
      // Remove existing structured data if any
      const existingScript = document.getElementById('structured-data-home');
      if (existingScript) {
        existingScript.remove();
      }

      // Organization structured data
      const organizationData = {
        "@context": "https://schema.org",
        "@type": "AccountingService",
        "name": "Afino Tax Consultants",
        "alternateName": "Afino Tax",
        "url": "https://www.afinotax.com",
        "logo": "https://www.afinotax.com/assets/img/logo.png",
        "description": "Trusted tax and accounting firm in Dubai, UAE. Expert Corporate Tax, VAT, Accounting, and Business Advisory services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "W8 building, 5th floor, DAFZA",
          "addressLocality": "Dubai",
          "addressRegion": "Dubai",
          "addressCountry": "AE"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+971-54-566-8994",
          "contactType": "customer service",
          "email": "sales@afinotax.com",
          "areaServed": "AE",
          "availableLanguage": ["English", "Arabic"]
        },
        "areaServed": {
          "@type": "Country",
          "name": "United Arab Emirates"
        },
        "serviceType": [
          "Corporate Tax Services",
          "VAT Services",
          "Accounting & Bookkeeping",
          "Business Advisory",
          "Audit Support",
          "Business Setup & Consultancy",
          "Economic Substance Regulation (ESR)",
          "AML & KYC Compliance",
          "Payroll & WPS Solutions"
        ],
        "priceRange": "$$",
        "sameAs": [
          "https://www.facebook.com/afinotax",
          "https://www.linkedin.com/company/afinotax",
          "https://www.instagram.com/afinotax"
        ]
      };

      // LocalBusiness structured data
      const localBusinessData = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Afino Tax Consultants",
        "image": "https://www.afinotax.com/assets/img/logo.png",
        "@id": "https://www.afinotax.com",
        "url": "https://www.afinotax.com",
        "telephone": "+971-54-566-8994",
        "email": "consulting@afinotax.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "W8 building, 5th floor, DAFZA",
          "addressLocality": "Dubai",
          "addressRegion": "Dubai",
          "postalCode": "",
          "addressCountry": "AE"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 25.2048,
          "longitude": 55.2708
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        }
      };

      // Website structured data
      const websiteData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Afino Tax Consultants",
        "url": "https://www.afinotax.com",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.afinotax.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      };

      // Create and append script tags
      const script1 = document.createElement('script');
      script1.id = 'structured-data-organization';
      script1.type = 'application/ld+json';
      script1.textContent = JSON.stringify(organizationData);
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.id = 'structured-data-localbusiness';
      script2.type = 'application/ld+json';
      script2.textContent = JSON.stringify(localBusinessData);
      document.head.appendChild(script2);

      const script3 = document.createElement('script');
      script3.id = 'structured-data-website';
      script3.type = 'application/ld+json';
      script3.textContent = JSON.stringify(websiteData);
      document.head.appendChild(script3);
    }
  },
  beforeUnmount() {
    // Clean up structured data when component is destroyed
    const scripts = [
      'structured-data-organization',
      'structured-data-localbusiness',
      'structured-data-website'
    ];
    scripts.forEach(id => {
      const script = document.getElementById(id);
      if (script) script.remove();
    });
  },
};
</script>
